import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { STORY_GENERATED_CONTENT_STATUS } from '../../../../constants';
import { useProject } from '../../../../context/ProjectContext';

const POLL_INTERVAL_MS = 10000;

function GeneratedContentUpdateController() {
  const { actions } = useProject();
  const generatedContent = useSelector((state) => state.story.generatedContent);
  const sessionId = useSelector((state) => state.story.sessionId);

  const hasPendingContent = generatedContent.some(
    (item) =>
      item.previewStatus === STORY_GENERATED_CONTENT_STATUS.PENDING ||
      item.contents.some((content) => content.contentStatus === STORY_GENERATED_CONTENT_STATUS.PENDING),
  );

  useEffect(() => {
    if (!hasPendingContent) {
      return;
    }

    const intervalId = setInterval(() => {
      actions('searchGeneratedContent');
    }, POLL_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
    };
  }, [actions, hasPendingContent]);

  useEffect(() => {
    if (sessionId) {
      actions('searchGeneratedContent');
    }
  }, [actions, sessionId]);

  return null;
}

export default GeneratedContentUpdateController;
